// ** React Imports
import { useEffect, useState } from 'react'

import { client } from 'src/utils/axios-client';
import { LeadScreenStore, LeadActivity, Lead, NextActivity, LeadAccountStore, ViewType, ActivityDialogStore, LeadCompanyStore, CompanyDialogStore, LeadSprintStore, SprintDialogStore, LeadActivityHistoryStore, ActivityHistoryDialogStore } from 'src/stores/LeadStore';
import { leadEndpoints } from '../../../configs/endpoints';

// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Tooltip from '@mui/material/Tooltip'
import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link';
import _ from 'lodash';
import LeadDataFormater from './LeadDataFormater';
import Badge, { BadgeProps } from '@mui/material/Badge';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RadialBarChart from '../../common/RadialBarChart';
import { previousDateDaysTooltip } from 'src/utils/date-utils';
import { previousDateDays } from 'src/utils/date-utils';
import StandardSkeleton from '../../common/StandardSkeleton';
import RenderIf, { ClaimType, ClaimValue } from '../../common/RenderIf';

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: 33,
        top: 10,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}));

const DoActivityHistoryInfo = () => {
    const activityRecord = LeadActivityHistoryStore.useState(s => s.record);
    const selectedLead = LeadScreenStore.useState(s => s.selectedLead);
    const [hasLoaded, setHasLoaded] = useState(false);

    useEffect(() => {
        const fetchActivityHistory = async () => {
            setHasLoaded(false);
            const response = await client.get(leadEndpoints.getactivityhistory.replace('{leadid}', "" + selectedLead?.id.toString()));
            LeadActivityHistoryStore.update(s => { s.record = response.data });
            setHasLoaded(true);
        }
        if (selectedLead != null) fetchActivityHistory();

        //if (!selectedLead) LeadAccountStore.update(s => { s = null });
    }, [])

    const viewActivityHistory = () => {
        ActivityHistoryDialogStore.update(s => { s.activityHistorDialogMode = true })
    };

    const viewMiHistory = () => {
        ActivityHistoryDialogStore.update(s => { s.miHistorDialogMode = true })
    };


    if (hasLoaded) {
        return (
            <Box>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card variant="outlined" sx={{pb: 4} }>
                            <CardContent>
                                <Box >
                                    <Grid container spacing={2} alignContent={'flex-end'}>
                                        <Grid item xs={12} md={6} sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                                            <Grid item xs={12} sx={{ alignItems: 'right' }} justifyContent={'flex-end'}>
                                                <Typography sx={{ fontSize: 20, color: 'CornflowerBlue' }} gutterBottom>
                                                    Activity History
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={12} sx={{ alignItems: 'right' }} justifyContent={'flex-end'}>
                                                <Grid item xs={12}>
                                                    <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                        {activityRecord.lastActivityname != '' && activityRecord.lastActivityDateTime != '' &&
                                                            <Tooltip title={previousDateDaysTooltip(activityRecord.lastActivityDateTime)} >
                                                                <Typography variant="caption" sx={{ fontStyle: 'italic' }} >Last Activity: {activityRecord.lastActivityname}{previousDateDays(activityRecord.lastActivityDateTime)} by {activityRecord.lastActivityOwnerName} Outcome: {activityRecord.lastActivityOutcomeName}</Typography>
                                                            </Tooltip>
                                                        }
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            <RenderIf claimType={ClaimType.Leads} claimValue={ClaimValue.ViewActivityHistory}>
                                                <Grid item xs={12} md={12} sx={{ alignItems: 'right' }} justifyContent={'flex-end'}>
                                                    <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                        <Tooltip title='All leads related to this sprint'>
                                                            <Link
                                                                underline="hover"
                                                                component="button"
                                                                variant="caption"
                                                                onClick={viewActivityHistory}
                                                            >
                                                                Touches ({activityRecord.activityCount})
                                                            </Link>
                                                        </Tooltip>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                        <Tooltip title='All leads related to this sprint'>
                                                            <Link
                                                                underline="hover"
                                                                component="button"
                                                                variant="caption"
                                                                onClick={viewMiHistory}
                                                            >
                                                                Meaningful Interactions ({activityRecord.miCount})
                                                            </Link>
                                                        </Tooltip>
                                                    </Box>
                                                </Grid>
                                            </RenderIf>
                                        </Grid>
                                        <Grid item xs={12} md={6} sx={{ alignItems: 'right' }} justifyContent={'flex-end'}>
                                            <Box display="flex" justifyContent="flex-end">
                                                <RadialBarChart subHeading="Contact Rate" seriesValue={activityRecord.connectionRate} toolTip="Contact Rate of meanigful Interactions per activity" />
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                                
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        )
    }
    else {
        return <StandardSkeleton />
    }

}

export { DoActivityHistoryInfo }

export default DoActivityHistoryInfo;